import React from "react";
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import { Button } from "react-bootstrap";
import { useManagePostRequest } from "../../../hooks/useManagePostRequest/useManagePostRequest";
import { useDescargarArchivoDeS3 } from "../../../hooks/useGenerarDescargarEliminarArchivo/useDescargarArchivoDeS3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faFilePowerpoint, faLock, faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import EditCampanaBonoTutoria from "../modales/Campanas/EditCampanaBonoTutoria";
import { activarCampanaBonoTutoriaAPI, cerrarCampanaBonoTutoria, cerrarCampanaBonoTutoriaAPI } from "../../../consumers/backendApisUrls";
import ActionGenericModal from "../../../components/modal/ActionGenericModal";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-regular-svg-icons";

const TableCampanaBonoTutoria = ({ formValues,
    setFormValues,
    setModalEnabled,
    paginator,
    setPaginator,
    keys: KEYS,
    successPostCallback
}) => {
    
    const rows = formValues.Items;

    const HEADERS = [
        { col: "col-sm-2", label: "Fecha Registro" },
        { col: "col-sm-2", label: "Nombre" },
        { col: "col-sm-2", label: "Fecha Inicio" },
        { col: "col-sm-2", label: "Fecha Fin" },
        { col: "col-sm-2", label: "Estado" },
        { col: "col-sm-2", label: "Acciones" }
    ]
   

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
                {rows.map((row, i) => (
                    <tr key={`${i}-${row.IdSolicitudBonoTutoria}`}>
                        <td className="text-center">{row.FechaCrea}</td>
                        <td>{row.NombreCampana}</td>
                        <td className="text-center">{row.FechaInicioCampana}</td>
                        <td className="text-center">{row.FechaFinCampana}</td>
                        <td className="text-center">
                            {row.EstadoCampana}
                        </td>
                        <td className="text-center">
                            {row.EstadoCampana != "Cerrado" && <FontAwesomeIcon
                                icon={faEdit}
                                size="lg"
                                className="hand-pointer generic-action-icon"
                                title="Editar"
                                onClick={() => {
                                    setModalEnabled({
                                        isEnable: true,
                                        component: EditCampanaBonoTutoria,
                                        data: { IdCampanaBonoTutoria: row.IdCampanaBonoTutoria },
                                    });
                                }}
                            />}
                            {row.EstadoCampana != "Activo" && row.EstadoCampana != "Cerrado" && <FontAwesomeIcon
                                icon={faCircleCheck}
                                size="lg"
                                className="hand-pointer generic-action-icon"
                                title="Activar Campaña"
                                onClick={() => setModalEnabled(
                                {
                                    isEnable: true, component: ActionGenericModal,
                                    data: {
                                        title: "Activar Campaña", actionLabel: "Activar",
                                        api: activarCampanaBonoTutoriaAPI,
                                        name: `${row.NombreCampana}`, item: "registro", payload: { IdCampanaBonoTutoria: row.IdCampanaBonoTutoria}
                                    }
                                })}
                            />}
                            {row.EstadoCampana == "Activo" && <FontAwesomeIcon
                                icon={faCircleXmark}
                                size="lg"
                                className="hand-pointer generic-action-icon"
                                title="Cerrar Campaña"
                                onClick={() => setModalEnabled(
                                {
                                    isEnable: true, component: ActionGenericModal,
                                    data: {
                                        title: "Cerrar Campaña", actionLabel: "Cerrar",
                                        api: cerrarCampanaBonoTutoriaAPI,
                                        name: `${row.NombreCampana}`, item: "registro", payload: { IdCampanaBonoTutoria: row.IdCampanaBonoTutoria}
                                    }
                                })}
                            />}
                        </td>
                    </tr>
                ))}
            </tbody>
        </PageTable>
    );
}

export default TableCampanaBonoTutoria;